<id-header-inera-admin
  class="ids-hide ids-show-inera-admin"
  [unresponsive]="false"
  brandtext="IdP Klientadministration">
  <id-header-inera-admin-nav type="inera-admin" slot="header-nav">
    @for (link of navItems; track $index) {
      <id-header-inera-admin-nav-item type="inera-admin" [active]="link.active">
        <a [routerLink]="link.link.route">{{ link.link.label }}</a>
      </id-header-inera-admin-nav-item>
    }
  </id-header-inera-admin-nav>

  @if (!loggedIn) {
    <id-header-inera-admin-item type="inera-admin" [separatorleft]="true">
      <span class="ids-icon-user" slot="icon"></span>
      <a routerLink="login">Logga in</a>
    </id-header-inera-admin-item>
  } @else {
    <id-header-inera-admin-item type="inera-admin" [separatorleft]="true">
      <span class="ids-icon-user" slot="icon"></span>
      <a [routerLink]="['/loggedout']">Logga ut</a>
    </id-header-inera-admin-item>
  }

  <!-- TODO: Fixa mobilmeny -->
  <!-- <id-header-inera-admin-nav-mobile>
    @for (link of navItems; track $index) {
      <id-mobile-menu-item slot="menu-link">
        <a [routerLink]="[link.link.route]" (click)="isMobileMenuOpen = !isMobileMenuOpen">{{ link.link.label }}</a>
      </id-mobile-menu-item>
    }

    @if (!loggedIn) {
      <id-mobile-menu-item slot="menu-link">
        <a routerLink="login">Logga in</a>
      </id-mobile-menu-item>
    } @else {
      <id-mobile-menu-item slot="menu-link">
        <a [routerLink]="['/loggedout']">Logga ut</a>
      </id-mobile-menu-item>
    }
  </id-header-inera-admin-nav-mobile> -->
</id-header-inera-admin>
